import styled from "styled-components";

export const MainWrapper = styled.div`
    margin: 72px 0 0 0;
    padding: 40px 15px 24px 15px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`

export const PageWrapper = styled.div`
    margin:  40px 0 0 0;
    padding: 40px 15px 24px 15px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`